import useRouteToUrl from 'src/internal/useRouteToUrl';
import useRoute from 'src/public/useRoute/useRoute';

import type {ActionProps} from '@sail/ui';

type HrefIn = ActionProps['href'];
type HrefOut = string | undefined;

export default function useActionHrefAdapter() {
  const [currentRoute] = useRoute();
  const routeToUrl = useRouteToUrl();

  return (href: HrefIn): HrefOut => {
    if (href == null || typeof href === 'string') {
      return href;
    }

    return routeToUrl(href, currentRoute);
  };
}
